module.exports = __webpack_public_path__ + "static/media/block-maps.731e84f6.svg";